import { ThemeProvider } from '@mui/material/styles';
import { ReactNode } from 'react';

import { skipcarTheme } from './theme';

import './skipcar-tokens.css';

interface NextThemeProviderProps {
  children: ReactNode;
}

export const NextThemeProvider = ({ children }: NextThemeProviderProps) => (
  <ThemeProvider theme={skipcarTheme}>
    <div className="theme-next">{children}</div>
  </ThemeProvider>
);
